import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { ApplicationConfig } from '../config/application.config';
import { Constant } from '../../shared/common/constant';
import { ApplicationActions } from '../../shared/store/application/application.actions';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private readonly store: Store) {}

  public intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const { url, urlWithParams, headers } = request;

    if (url.startsWith(ApplicationConfig.apiUrl)) {
      if (!headers.has(Constant.HTTP_SILENT_MODE)) {
        this.store.dispatch(
          new ApplicationActions.SetLoading(true, urlWithParams)
        );

        return next.handle(request).pipe(
          finalize(() => {
            this.store.dispatch(
              new ApplicationActions.SetLoading(false, urlWithParams)
            );
          })
        );
      }

      return next.handle(request);
    } else {
      return next.handle(request);
    }
  }
}
